<template>
  <div :id="uppyId">
    <div class="DashboardContainer"></div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  const Uppy = require('@uppy/core');
  const XHRUpload = require('@uppy/xhr-upload');
  const Dashboard = require('@uppy/dashboard');
  const Polish = require('./pl_PL');

  // And their styles (for UI plugins)
  require('@uppy/core/dist/style.css');
  require('@uppy/dashboard/dist/style.css');

  export default {

    data() {
      return {
        endpoint: 'attachments/upload',
        modelClass: 'uppy',
        modelId: 'uppyId',
        collection: 'thumbnails',
      }
    },

    computed: {
      ...mapState({
        token: state => state.auth.token,
        filesLeft: state => state.settings.attachments.maxFiles - state.attachments.attachments.length,
        maxFileSize: state => state.settings.attachments.maxFileSize,
      }),
      uppyId() {
        return this.modelClass + '-' + this.modelId + '-' + this.collection;
      }
    },

    mounted() {
      const uppy = Uppy({
        id: this.uppyId,
        autoProceed: false,
        debug: false,
        locale: Polish,
        restrictions: {
          maxFileSize: this.maxFileSize,
          maxNumberOfFiles: this.filesLeft,
          allowedFileTypes: ['image/jpeg', 'image/gif', 'image/png', 'application/pdf']
        },
        meta: {
          modelClass: this.modelClass,
          modelId: this.modelId,
          collection: this.collection
        },
        onBeforeFileAdded: () => {
          Promise.resolve()
        },
        onBeforeUpload: () => {
          Promise.resolve()
        },
      });

      uppy.use(Dashboard, {
        inline: true,
        proudlyDisplayPoweredByUppy: false,
        target: '.DashboardContainer',
        replaceTargetContent: true,
        note: 'Tylko zdjęcia i PDF.',
        maxHeight: 500,
      });
      uppy.use(XHRUpload, {
        endpoint: process.env.VUE_APP_API_URI + this.endpoint,
        fieldName: 'file',
        headers: {
          'Authorization': `Bearer ${this.token}`
        },
      });

      uppy.on('upload-success', (file, response) => {
        this.$emit('upload-success', response)
      });

      uppy.on('upload-error', (file, error, response) => {
        if (400 === response.status && response.body.hasOwnProperty('message')) {
          uppy.info({ message: response.body.message }, 'error', 5000);
        }
      });

      uppy.on('complete', (result) => {
        if (result.failed.length === 0) {
          this.$emit('complete-success')
        }
      });

      uppy.run();
    },

    methods: {},
  }
</script>

<style>
  .uppy-Dashboard-inner {
    border: unset;
    background-color: #fff;
    border-radius: 0 0 .3rem .3rem;
  }
</style>
